import { Statistics } from '../../pages';
import { Tasks, Campaigns, CampaignMonitoring } from '../../pages';
import { Contacts, Webhooks, Prompts, Messages } from '../../pages';

const mainMenuRoutes: AppRouteType[] = [
  {
    icon: 'list',
    url: '/tasks',
    menuTitle: 'Tasks',
    pageTitle: 'Tasks Management',

    component: Tasks,
  },
  {
    icon: 'rocket',
    url: '/campaigns',
    menuTitle: 'Campaigns',
    pageTitle: 'Campaigns Management',

    component: Campaigns,
  },
  {
    icon: 'eye',
    url: '/campaign_monitoring',
    menuTitle: 'Campaign Monitoring',

    component: CampaignMonitoring,
  },
  {
    icon: 'people',
    url: '/contacts_management',
    menuTitle: 'Contacts',
    pageTitle: 'Contacts Management',

    component: Contacts,
  },
  {
    icon: 'messages',
    url: '/messages_history',
    menuTitle: 'Messages',
    pageTitle: 'Messages History',

    component: Messages,
  },
  {
    icon: 'hook',
    url: '/webhook_events',
    menuTitle: 'Webhook Events',

    component: Webhooks,
  },
  {
    icon: 'document',
    url: '/system_prompts',
    menuTitle: 'Prompts',
    pageTitle: 'System Prompts',

    component: Prompts,
  },
  {
    icon: 'chart',
    url: '/system_statistics',
    menuTitle: 'Statistics',
    pageTitle: 'System Statistics',

    component: Statistics,
  },
];

export const getRoutes: (meta: AppMetaType) => AppRouteType[] = _meta => {
  return mainMenuRoutes;

  // return [
  //   {
  //     groupTitle: 'Main Menu',
  //     routes: mainMenuRoutes,
  //   },
  // ];
};
